<script>
import PageHeader from "@/components/page-header";
import Pagination from "@/router/layouts/table-pagination.vue";
import Datatable from "@/router/layouts/table-datatable.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "dashboard-demo",
  components: {
    PageHeader,
    Pagination,
    Datatable,
  },
  data() {
    let sortOrders = [];
    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "Kompetensi", name: "nama_kompetensi" },
      { width: "150px", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    const menu = "Dashboard Ujian Demo";

    return {
      title: menu,
      info_demo: "",
      loadingTable: true,
      tableData: [],
      columns: columns,
      sortKey: "created_at",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "",
        dir: "desc",
        status: "2",
        tools: "Lengkap",
        kompetensi: "",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  methods: {
    async getInfo() {
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/info-ujian/dummy",
        headers: {
          Accept: "application/json",
        },
      }).then((response) => response.data.data);
      console.log({data});
      if (data) {
        this.info_demo = data;
      }
    },
    async getTableData() {
      this.loadingTable = true;
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "kompetensi-demo",
        params: this.tableFilter,
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableData = data.data.data;
        this.currentTablePage = data.data.current_page;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getTableData();
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getTableData();
    },
    async demoUjian(idkompetensi) {
      console.log(idkompetensi);
      await Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin memulai demo ujian kompetensi ini ?",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Loading...",
            allowOutsideClick: false,
            showConfirmButton: false,
          });

          // get ipaddress
          // const ipAddress = await $.getJSON(
          //   'https://api.ipify.org?format=json',
          //   function (data) {
          //     return data;
          //   },
          //   function () {
          //     return {};
          //   }
          // );

          // request token sso
          const res = await axios({
            method: "get",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "kompetensi-demo/" +
              idkompetensi +
              "/demo",
            params: {
              ipAddress: "8.8.8.8",
              browser: "Chrome",
            },
          })
            .then((response) => response.data.data)
            .catch((err) => {
              console.log(err);
              return false;
            });
          const tokenSSO = res ? res.token : false;
          const uniqueId = res ? res.uniqueId : false;
          localStorage.setItem("uniqueId", uniqueId);
          localStorage.setItem("is_demo", true);

          if (tokenSSO) {
            this.$router.push({
              name: "dashboard-assesmen-hc",
              query: {
                sso: tokenSSO,
                isSimulation: true,
                isDemo: true,
              },
            });
          }
        }
      });
      Swal.close();
    },
  },
  mounted() {
    this.getInfo();
    this.getTableData();
  },
};
</script>

<template>
  <div class="card">
    <div
      class="card-header bg-primary text-white font-size-20 font-weight-semibold text-center"
    >
      <img
        src="@/assets/images/logo-pln.png"
        height="40"
        style="position: absolute; left: 12px; top: 5px"
      />
      Asesmen Hard Competency
    </div>
  </div>
  <div class="container-fluid mt-2">
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div
            class="card-header bg-primary text-white font-size-16 rounded-top"
          >
            Informasi Ujian Demo
          </div>
          <div class="card-body" style="height: 300px; overflow-y: auto">
            <div class="info-ujian" v-html="info_demo"></div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <div
            class="card-header bg-primary text-white font-size-16 rounded-top"
          >
            Daftar Kompetensi
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-3 mb-2">
                <label for="filterKode">Kompetensi</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Filter Kompetensi..."
                />
              </div>
            </div>
            <hr />
            <table class="mb-2">
              <tr>
                <td>Show</td>
                <td>
                  <select
                    class="form-control form-control-sm"
                    id="showpaginatetable"
                    v-model="tableFilter.per_page"
                    @change="getDataTable()"
                  >
                    <option value="10">10</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                  </select>
                </td>
                <td>Entries</td>
              </tr>
            </table>
            <datatable :columns="columns">
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="99" class="text-center">
                    <i class="fa fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="tableData.length < 1">
                  <td colspan="99" class="text-center">Data Empty</td>
                </tr>
                <tr v-else v-for="(item, key) in tableData" :key="key">
                  <td>
                    <span v-if="key + 1 == 10"> {{ currentTablePage }}0. </span>
                    <span v-else>
                      {{
                        currentTablePage - 1 != 0
                          ? currentTablePage - 1 + `${key + 1}`
                          : `${key + 1}`
                      }}.
                    </span>
                  </td>
                  <td>{{ item.nama_kompetensi }}</td>
                  <td class="text-center">
                    <div class="btn-group btn-group-sm">
                      <button
                        class="btn btn-primary"
                        @click="demoUjian(item.idkompetensi)"
                      >
                        <i class="fa fa-desktop me-1"></i>
                        Mulai Demo
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <pagination :pagination="pagination" @to-page="toPage" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
